// This file defines the layers for the North America region by merging the non-authenticated and common authenticated TOCs with specific layers for North America.
import { non_authenticated, common_authenticated } from '@/constants/layers/index'

// Importing non-authenticated and common authenticated TOCs

// Reference layers for North America
import RelativeNDVI from '@/constants/layers/referenceLayers/relativeNDVI.ts'
import Counties from '@/constants/layers/region/northAmerica/reference/counties'
import DroughtMonitor from '@/constants/layers/region/northAmerica/reference/droughtMonitor'
import MicrosoftBuildings from '@/constants/layers/region/northAmerica/reference/microsoftBuildings'
import NifsPublicPerimeter from '@/constants/layers/region/northAmerica/reference/NifsPublicPerimeters'
import PredictiveServiceAreas from '@/constants/layers/region/northAmerica/reference/predictiveServiceAreas'
import States from '@/constants/layers/region/northAmerica/reference/states'
import { mergeTocs } from '@/utils/layers'

// Risk layers for North America
import { burningIndexNA } from './riskLayers/burningIndex'
import { energyReleaseNA } from './riskLayers/energyReleaseIndex'
import { fireDangerNA } from './riskLayers/fireDangeIndex'

export const northAmericaLayers = mergeTocs(non_authenticated.toc, common_authenticated.toc, [
  { name: 'riskLayers', layers: [burningIndexNA, energyReleaseNA, fireDangerNA] },
  {
    name: 'reference',
    layers: [RelativeNDVI, States, Counties, NifsPublicPerimeter, DroughtMonitor, MicrosoftBuildings, PredictiveServiceAreas]
  }
  // Add other toc groups if needed
])
